<template>
  <header class="header header--mobile" :class="{ 'header--ios': view.isIOS }">
    <div class="header__inner">
      <div class="header__title-wrapper">
        <h1 class="header__title">
          {{ title }}
        </h1>
      </div>
      <DocsSortButtonMobile v-if="hasDocSort" />
      <StartFreeTrialButton
        v-if="view.showCtaButtonOnMobile"
        class="header__trial-btn"
        :view="view"
      />
      <HeaderUserMenu :view="view" />
    </div>
    <slot></slot>
  </header>
</template>

<script setup lang="ts">
import { onBeforeMount, Raw, ref } from 'vue'

import { HeaderView } from '@/models/header'

import HeaderUserMenu from './UserMenu.vue'
import StartFreeTrialButton from './StartFreeTrialButton.vue'
import DocsSortButtonMobile from '@/app/components/listing/DocsSortButton.mobile.vue'

withDefaults(
  defineProps<{
    title: string
    hasDocSort?: boolean
  }>(),
  {
    hasDocSort: false,
  },
)

const view = ref<Raw<HeaderView>>(new HeaderView())

onBeforeMount(async () => {
  await view.value.init()
})
</script>

<style>
/**
 * The styles for this component are defined in `@/assets.app/css/components/_header.scss`
 */
</style>
